import React, { useReducer } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ai from "../../helpers/axios";
import AsyncSelect from "react-select/async";

let initialState = {};

const reducer = (state, action) => {
  switch (action.type) {
    case "fieldChanged": {
      let value =
        action.fieldType === "number" ? parseInt(action.value) : action.value;

      return {
        ...state,
        [action.field]: value,
      };
    }

    case "resetState": {
      return {
        ...initialState,
      };
    }

    default:
      break;
  }
  return state;
};

const RegionAutocomplete = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const loadRegionOptions = async (inputValue) => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let { data } = await ai
      .auth(token)
      .get(`/api/regions/search?q=${inputValue}`);

    let options = [];
    if (data.length >= 1) {
      options = data.map((region) => ({
        value: region._id,
        label: region.name,
      }));
    }

    return options;
  };

  return (
    <div className="form-group">
      <label>{props.label || "Region"}</label>

      <AsyncSelect
        className="region-select"
        classNamePrefix="select"
        loadOptions={loadRegionOptions}
        placeholder={props.placeholder || "Select a Region"}
        onChange={props.handleRegionChange}
        isClearable={true}
        cacheOptions
        defaultOptions
        value={props.selectedRegion}
        isMulti={props.isMulti || false}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      ></AsyncSelect>
    </div>
  );
};

export default RegionAutocomplete;
